import { render, staticRenderFns } from "./SVGImage.vue?vue&type=template&id=5c8199fa&scoped=true"
import script from "./SVGImage.vue?vue&type=script&lang=js"
export * from "./SVGImage.vue?vue&type=script&lang=js"
import style0 from "./SVGImage.scss?vue&type=style&index=0&id=5c8199fa&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8199fa",
  null
  
)

export default component.exports